import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'ui-video',
	templateUrl: './video.component.html',
})
export class UIVideoComponent implements OnInit {
	@Input() platform: string = '';
	@Input() id: string = '';
	@Input() autoplay: boolean = false;

	url: string = null;

	ngOnInit(): void {
		switch (this.platform) {
			case 'vimeo':
				this.url =
					'https://player.vimeo.com/video/' +
					this.id +
					'?autoplay=' +
					(this.autoplay === true ? '1' : '0') +
					'&badge=0&byline=0&title=0';
				break;
			case 'youtube':
				this.url =
					'https://www.youtube.com/embed/' +
					this.id +
					'?autoplay=' +
					(this.autoplay === true ? '1' : '0') +
					'&rel=0&controls=1&modestbranding=1';
				break;
		}
	}
}
